__turbopack_context__.v({
  "FloatingWidgetContainer": "dPNOsq_FloatingWidgetContainer",
  "expanded": "dPNOsq_expanded",
});
